import { z } from 'zod';
/** Account ▸ Mailbox — a rep's own Gmail/Microsoft 365 mailbox,
 * OAuth-connected send-only (Gmail `gmail.send`, Graph `Mail.Send`) so a
 * reply sent from inside Orion goes out from the same address a lead's
 * original outreach came from. Self-service, scoped to the caller's own
 * membership — there's no admin surface to connect someone else's
 * mailbox, since the OAuth consent has to come from the account owner.
 * Deliberately separate from Inbox Pulse's own (read-only) mailbox
 * connection. */
export const mailboxConnectionResponseSchema = z.object({
    id: z.string().uuid(),
    provider: z.enum(['google', 'microsoft']),
    status: z.enum(['active', 'needs_reconnect', 'disabled']),
    emailAddress: z.string(),
    scopes: z.array(z.string()),
    lastUsedAt: z.string().datetime().nullable(),
    lastError: z.string().nullable(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=schemas.js.map